import React from 'react'
import { Button, Icon, Element } from 'react-bulma-components'
import { BanIcon, CheckIcon } from '../../icons'
import { useModal } from '../../modal'
import ConfirmationModal from '../../confirmation-modal/confirmation-modal'
import { useUpdateWorkerEmployerCollaborationMutation } from '../../../queries/users'
import { User } from '../../../api/users'
import { ButtonProps } from '../../../types/bulma'

interface ActiveEmployerCollaborationButtonProps {
  user: User
  isInactive?: boolean
  label?: string
  color?: ButtonProps['color']
}

const ActiveEmployerCollaborationButton: React.FC<ActiveEmployerCollaborationButtonProps> = ({
  user,
  isInactive,
  label,
  color = isInactive ? 'primary' : 'danger',
}) => {
  const employerCollaborationModal = useModal()
  const setEmployerCollaborationMutation = useUpdateWorkerEmployerCollaborationMutation()

  const handleActiveEmployerCollaborationToggle = async () => {
    if (!user) return

    await setEmployerCollaborationMutation.mutateAsync({
      workerId: user._id,
      isInactive: !isInactive,
    })
    employerCollaborationModal.setIsDisplayed(false)
  }

  return (
    <>
      <Button
        color={color}
        textColor="white"
        size="small"
        onClick={() => employerCollaborationModal.setIsDisplayed(true)}
        data-test="active-employer-collaboration-btn"
      >
        <Icon>{isInactive ? <CheckIcon /> : <BanIcon />}</Icon>
        <Element renderAs="span">
          {label || (isInactive ? 'Réintégrer' : 'Ne plus travailler avec cet intérimaire')}
        </Element>
      </Button>

      <ConfirmationModal
        show={employerCollaborationModal.isDisplayed}
        onConfirm={handleActiveEmployerCollaborationToggle}
        onCancel={() => employerCollaborationModal.setIsDisplayed(false)}
        confirmButtonProps={{
          color: isInactive ? 'primary' : 'danger',
          disabled: false,
        }}
        title={isInactive ? "Réintégrer l'intérimaire" : 'Ne plus travailler avec cet intérimaire'}
        confirmButtonLabel={isInactive ? 'Réintégrer' : 'Ne plus travailler avec'}
      >
        <Element>
          {isInactive
            ? 'Êtes-vous sûr de vouloir réintégrer cet intérimaire ? Il pourra à nouveau être affecté à des missions par les agences.'
            : "Êtes-vous sûr de ne plus vouloir travailler avec cet intérimaire ? Les agences ne pourront plus l'affecter à vos missions."}
        </Element>
      </ConfirmationModal>
    </>
  )
}

export default ActiveEmployerCollaborationButton
